import axios from 'axios';
import envConfig from '../envConfig';

// Endpoints where a 401 means "bad credentials", not "session expired".
// These pages surface the error themselves, so we must not force a logout.
const anonymousRoutes = [
  'auth/login',
  'auth/register',
  'auth/request/reset',
  'auth/reset'
];

const api = axios.create({
  baseURL: envConfig.ApiUrl,
  headers: {
    'Ocp-Apim-Subscription-Key': envConfig.ApiKey,
    Authorization: `Bearer ${window?.localStorage ? window?.localStorage?.getItem(`${envConfig.StoragePrefix}-token`) : ''}`
  },
  timeout: 2700000
});

api.interceptors.request.use(
  (request) => {
    if (request && request?.headers && window && window?.localStorage) {
      request.headers['Accept-Language'] = `${window?.localStorage?.getItem(`${envConfig.StoragePrefix}-lang`)}-US`.replaceAll('"', '');
      request.headers.Authorization = `Bearer ${window?.localStorage?.getItem(`${envConfig.StoragePrefix}-token`)}`.replaceAll('"', '');
    }
    return request;
  }, function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  function (error) {
    const url = error?.config?.url ?? '';
    const isAnonymousRoute = anonymousRoutes.some((route) => url.includes(route));

    if (error?.response?.status === 401 && !isAnonymousRoute) {
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
      // Full reload, so in-memory Recoil state is rebuilt from the cleared storage.
      // Guarded to avoid a reload loop if we are already on the login page.
      if (window?.location?.pathname !== '/') {
        window.location = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
